import { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import Sortable from "sortablejs";
import { Image, LI } from "../../../AbstractElements";
import { DraggableFiltering } from "../../../Constants/Constants";
import { DraggableFilteringData } from "../../../Data/BonusUi/Tree";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DraggableFilterList = () => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      Sortable.create(listRef.current, {
        filter: ".filtered",
        animation: 150,
      });
    }
  }, []);

  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={DraggableFiltering} span={DraggableFilteringData} />
        <CardBody className="draggable-filter">
          <ul className="list-group" id="draggable-filter" ref={listRef}>
            <LI>
              <Image className="rounded-circle" src={dynamicImage(`user/1.jpg`)} alt="user" />
              Teresa J. Mosteller
            </LI>
            <LI>
              <Image src={dynamicImage(`user/3.png`)} alt="user" />
              Gloria D. Acheson
            </LI>
            <LI className="filtered list-light-primary">
              <Image src={dynamicImage(`user/2.jpg`)} alt="user" />
              Sharon C. Obrien
            </LI>
            <LI>
              <Image src={dynamicImage(`user/5.jpg`)} alt="user" />
              Bryan A. Owens
            </LI>
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DraggableFilterList;
